import { create } from "zustand";
import { querystring } from "zustand-querystring";

type StorefrontLinksV2Customer = {
  name: string;
  connectionId: number;
  logoUrl: string;
  postalCode: string;
  priceTierName: string;
  availabilityTierName: string;
};

type StorefrontLinksV2StoreState = {
  selectedConnectionId: number | null;
  customer: StorefrontLinksV2Customer | null;
};

type StorefrontLinksV2StoreActions = {
  setSelectedConnectionId: (selectedConnectionId: number | null) => void;
  setCustomer: (customer: StorefrontLinksV2Customer | null) => void;
  reset: () => void;
};

const initialState: StorefrontLinksV2StoreState = {
  selectedConnectionId: null,
  customer: null,
};

type StorefrontLinksV2StoreType = StorefrontLinksV2StoreState &
  StorefrontLinksV2StoreActions;

export const useStorefrontLinksV2Store = create<StorefrontLinksV2StoreType>()(
  querystring<StorefrontLinksV2StoreType>(
    (set) => ({
      ...initialState,
      setSelectedConnectionId: (selectedConnectionId) =>
        set({ selectedConnectionId }),
      setCustomer: (customer) =>
        set({
          customer,
          selectedConnectionId: customer?.connectionId ?? null,
        }),
      reset: () => set(initialState),
    }),
    {
      select(pathname) {
        const persistParam = pathname.includes("/storefront-links");
        return {
          selectedConnectionId: persistParam,
          customer: persistParam,
        };
      },
    },
  ),
);
